import router from './router'
import store from './store'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import message from 'ant-design-vue/es/message'

import { getToken } from '@/utils/auth'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'

NProgress.configure({ showSpinner: false })
const whiteList = ['login', 'register', 'resetPassword', 'registerResult', 'exception', 'agreement', 'homePage', 'wow', 'wowShare']

router.beforeEach((to, from, next) => {
  NProgress.start()
  to.meta && (typeof to.meta.title !== 'undefined' /*&& setDocumentTitle(`${to.meta.title} - ${domTitle}`)*/)
  if (getToken()) {
    if (!store.getters.isLogin) { // 如果没有用户信息
      store.dispatch('GetInfo').then(res => { // 获取用户信息
        if (res.authentication_status != '2' && to.path === '/texture/imageUpload') { // 禁止没有认证通过的跳转到上传页   用户认证状态 @0:未认证 @1:认证中 @2：认证成功 @3:认证失败
          next({ path: '/404' })
        } else if (res.effective_customers == 0 && to.path === '/personEditor') {
          next({ path: '/404' })
        } else {
          if (to.path === '/user/login') {
            next({ path: '/manage/chartlet' })
          } else if (to.path === '/homePage' || to.path === '/') {
            next({ path: '/manage/chartlet' })
          } else {
            next()
          }
        }
        NProgress.done()
      }).catch(() => {
        message.error('未登录或授权信息过期，请重新登录')
        store.dispatch('Logout').then(() => {
          next({ path: '/user/login', query: { redirect: to.fullPath } })
        })
      })
    } else {
      const userInfo = store.state.user.info
      if (userInfo.authentication_status != '2' && to.path === '/texture/imageUpload') { // 禁止没有认证通过的跳转到上传页    用户认证状态 @0:未认证 @1:认证中 @2：认证成功 @3:认证失败
        next({ path: '/404' })
      } else if (to.path === '/homePage' || to.path === '/') {
        if (from.path === '/manage/materialDirection') {
          next({ path: '/manage/materialDirection' })
        } else {
          next({ path: '/manage/chartlet' })
        }
      } else if (to.path === '/user/register' && '/manage/materialDirection') {
        next({ path: '/manage/materialDirection' })
      } else {
        next()
      }
      NProgress.done()
    }
  } else {
    console.log(to)
    if (whiteList.includes(to.name)) {
      next()
      NProgress.done()
    } else {
      next({ path: '/homePage' })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
